import { Immutable } from "immer";
import React from "react";

import { getDescribedByElemID } from "../hooks/formUtils";

/**
 * Renders ADA screenreader text
 */
export const FormAdaText = (
    props: Immutable<{
        id?: string;
        adaText?: string;
    }>,
): React.ReactNode => {
    if (!props.adaText || !props.id) {
        return null;
    }

    return (
        <span
            className="ada-screenreader-only"
            id={getDescribedByElemID(props.id)}
        >
            {props.adaText}
        </span>
    );
};
